import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import '../../styles/modal/CoreModal.css';
import '../../styles/boat/BoatLeadModal.css';
import CustomBoatLeadForm from '../../forms/boats/CustomBoatLeadForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { validateBoatLeadForm } from '../../validations/BoatLeadValidation';
import BoatLeadSuccessModal from '../BoatsPage/BoatLeadSuccessModal';
import BoatLeadService from '../../services/BoatLeadService';

const CustomBoatLeadModal = ({ onClose, catering = false, decorations = false }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    date: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleResetAndClose = () => {
    setFormData({
      fullName: '',
      email: '',
      phone: '',
      date: '',
      message: '',
    });
    setShowSuccessModal(false);
    onClose();
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setErrors({});
    const validationErrors = validateBoatLeadForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      const newLead = {
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        date: formData.date || null,
        message: formData.message || null,
        boat: null
      };
      if (catering) {
        newLead.lead_type = 'catering';
      }

      console.log('Sending lead data:', newLead);
      const response = await BoatLeadService.createLead(newLead);
      console.log('Lead creation response:', response);
      setShowSuccessModal(true);
    } catch (error) {
      console.error('Error creating lead:', error);
      setErrors({ submit: 'Error sending the form. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const stopPropagation = (e) => e.stopPropagation();

  return createPortal(
    <div className="core__modal" onClick={handleResetAndClose}>
      <div className="core__modal-content" onClick={stopPropagation}>
        <div className="core__modal-header">
          <h3>{ 
            decorations ? 'Book your deco now!' : 
            catering ? 'Book your catering now!' : 
            'Book your spot now!' 
          }</h3>
          <button className="core__modal-close" onClick={handleResetAndClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="core__modal-body">
          <p className="core__modal-intro-text">
            Please note this is only a request. We will contact you to finalize your booking.
          </p>
          <CustomBoatLeadForm formData={formData} errors={errors} handleChange={handleChange} />
          {errors.submit && <span className="error-message">{errors.submit}</span>}
          <div className="privacy-assurance">
            <FontAwesomeIcon icon={faShieldAlt} />
            <span>We won't share your data.</span>
          </div>
          <div className="core__modal-buttons">
            <button className="button" onClick={handleSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Book Call'}
            </button>
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <BoatLeadSuccessModal 
          onClose={handleResetAndClose}
        />
      )}
    </div>,
    document.getElementById('core-app')
  );
};

export default CustomBoatLeadModal;
